import React from 'react';
import { buildSocialLinks } from '../../utils/socialLinks';

const SocialLinks = ({ socialMedia, className = 'social-links' }) => {
  const links = buildSocialLinks(socialMedia);

  if (links.length === 0) return null;

  return (
    <div className={className}>
      {links.map(({ url, Icon, label }) => (
        <a
          key={label}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="social-link"
          aria-label={label}
        >
          <Icon />
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;
